// extracted by mini-css-extract-plugin
export default {"item-list":"AppetizersDesktop_item-list__Ac5tU","item":"AppetizersDesktop_item__tFLiG","section":"AppetizersDesktop_section__b45NF"};